import {
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PhysicianService } from '@core/service';
import { PhysicianAccountPgpsDTO } from '@mynexus/mynexus-ui-lib';
import { finalize } from 'rxjs/operators';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-physician-search',
    templateUrl: './physician-search.component.html',
    styleUrls: ['./physician-search.component.scss'],
    standalone: false
})
export class PhysicianSearchComponent implements OnInit {
  @Input() tenantId: string;
  @Input() physicianType: string;
  @Input() label = '';
  @Input() displayFollowingCheckbox = false;
  @Input() isDefaultViewMode = false;
  @Input() sameAsOrdering = false;
  @Input() npiNotFound = false;
  @Input() isPhysicianNotFoundView = false;
  @Input() isHhAuthForPacUser = false;
  @Input() showAddNewProvider = false;

  @Output() physicianResultList = new EventEmitter<PhysicianAccountPgpsDTO[]>();
  @Output() sameAsOrderingChange = new EventEmitter<boolean>();
  @Output() npiNotFoundChange = new EventEmitter<boolean>();
  @Output() showAddNewProviderChange = new EventEmitter<boolean>();

  isLoading = false;
  searchText: string;
  searchForm: FormGroup;
  npiCheck = new FormControl();
  sameAsOrderingCheck = new FormControl();
  showAddBtn = false;

  constructor(
    private readonly physicianService: PhysicianService,
    private readonly destroyRef: DestroyRef,
  ) {}

  ngOnInit() {
    this.buildPhysicianSearchForm();
    this.setCheckbox();
  }

  buildPhysicianSearchForm() {
    this.searchForm = new FormGroup({
      searchText: new FormControl('', [
        Validators.required,
        Validators.minLength(10),
      ]),
    });

    this.searchFormWatch();
    this.checkboxWatch();
  }

  searchFormWatch(): void {
    this.searchForm.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((val) => {
        this.searchText = val.searchText;
      });
  }

  setCheckbox() {
    if (this.npiNotFound) {
      this.npiCheck.setValue(true);
    }

    if (this.sameAsOrdering) {
      this.sameAsOrderingCheck.setValue(true);
    }
  }

  checkboxWatch() {
    this.npiCheck.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) =>
        this.npiNotFoundChange.emit(res)
      );

    this.sameAsOrderingCheck.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) =>{
        this.npiCheck.setValue(false);
        this.sameAsOrderingChange.emit(res)
      });
  }

  searchNPI() {
    this.isLoading = true;
    
    this.physicianService
    .getActivePhysicianAccountPgpsByNpi(this.searchText, this.tenantId)
    .pipe(finalize(() => (this.isLoading = false)))
    .subscribe((physicianList) => {
      this.sameAsOrderingCheck.reset();
      this.physicianResultList.emit(physicianList);
      this.isPhysicianNotFoundView = !physicianList?.length;
      this.showAddBtn = true;
      this.showAddNewProviderChange.emit(false);
    });
  }

  addNewProvider(): void {
    this.showAddBtn = false;
    this.npiNotFoundChange.emit(true)
    this.showAddNewProviderChange.emit(true)
  }
}
